import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Input,
  Button,
  Row,
  Col,
  FormGroup,
  Label,
  FormFeedback,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import usePersistStoreData from "../Hooks/usePersistStoreData";
import { Formik, Field, ErrorMessage, Form } from "formik";
import * as Yup from "yup";

const EditGenderModal = ({ edit_gender, close_editGender }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userData } = usePersistStoreData();
  const token = userData?.token;
  

  const initialValues = {
    user_gender: "",
    
  };
  const validationSchema = Yup.object({
    user_gender: Yup.string()
  .required("Please select marital status"),

    
  });

  const statusOptions = [
    {key:"1", label:"Male"},
    {key:"2", label:"Female"},
    {key:"3", label:"Prefer Not to Say"},
  
  ]

  return (
    <Modal isOpen={edit_gender} centered={true} className="contact_modal_custom">
      <ModalHeader
        toggle={close_editGender}
        style={{
          backgroundColor: "#0F528D",
          paddingTop: "0.75rem",
          paddingBottom: "0.75rem",
        }}
      >
        <span className="fs-16 contact_note_header ">Edit Gender Status</span>
      </ModalHeader>
      <ModalBody className="">
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            console.log("Form values:", values);
            close_editGender();
          }}
        >
          {(formik) => (
            <Form onSubmit={formik.handleSubmit}>
              <ModalBody className="p-0">
                <Row className="row m-0 p-0">
                  <Col xxl={12} className="ps-0">
                    <FormGroup>
                      <Label for="user_gender">Gender *</Label>
                      <Input
                        type="select"
                        name="user_gender"
                        id="user_gender"
                        className="form-control"
                        placeholder="Enter name"
                        value={formik.values.user_gender}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.user_gender && !!formik.errors.user_gender
                        }
                      >
                        <option  value="" disabled>Select Option</option>
                        {statusOptions?.map((item,index) => (
                          <option value={item?.key} key={item?.key}>{item?.label}</option>
                        ))}
                         </Input>
                      
                      <FormFeedback>{formik.errors.user_gender}</FormFeedback>
                    </FormGroup>
                  </Col>

               
                </Row>
              </ModalBody>
              <div className="centerContent">
                <Button
                  className="fs-16"
                  color="primary"
                  type="submit"
                  style={{
                    minWidth: "120px",
                  }}
                >
                  Save
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

export default EditGenderModal;
